// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setLivePreview } from './live-preview.action';
import { setPreviewSecurities } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/preview-securities/preview-securities.action';
export const live_preview = createReducer(false, on(setLivePreview, (state, action) => {
    return action.live_preview;
}), on(setPreviewSecurities, () => {
    return true;
}));
